<template>
  <div>
    <h5>プロフィールの変更</h5>
    <hr>

    <!--<h6 class="mt-5 mb-4 py-3 pl-3" style="background-color: #fbfcad;border-radius: 4px;"></h6>-->
    <div class="">
        <!-- <div class="card-header"></div> -->
        <div class="mb-5"> 

            <div class="form-group">
                <div class="col-sm-12 px-1">
                    <label class="col-sm-12 control-label">ハンドルネーム（レビュー、コメントで使用します）  <span class="required_mark">必須</span></label>
                    <input type="text" placeholder="" v-model="userForm.nickname" class="required form-control" v-bind:class="{ error_input: userForm.errors.nickname.length > 0 }">
                    <div v-if="userForm.errors.nickname.length > 0">
                      <div class="error-text" v-for="(item, index) in userForm.errors.nickname" :key="index">{{ item }}</div>
                    </div>
                </div>
            </div>

            <div class="form-group row mx-0">
                <div class="px-1 col-6">
                    <label class="col-sm-6 control-label">姓  <span class="required_mark">必須</span></label>
                    <input type="text" placeholder="山本" v-model="userForm.last_name" class="required form-control" v-bind:class="{ error_input: userForm.errors.last_name.length > 0 }">
                    <div v-if="userForm.errors.last_name.length > 0">
                      <div class="error-text" v-for="(item, index) in userForm.errors.last_name" :key="index">{{ item }}</div>
                    </div>
                </div>
                <div class="px-1 col-6">
                    <label class="col-sm-6 control-label">名  <span class="required_mark">必須</span></label>
                    <input type="text" placeholder="太郎" v-model="userForm.first_name" class="required form-control" v-bind:class="{ error_input: userForm.errors.first_name.length > 0 }">
                    <div v-if="userForm.errors.first_name.length > 0">
                      <div class="error-text" v-for="(item, index) in userForm.errors.first_name" :key="index">{{ item }}</div>
                    </div>
                </div>
            </div>

            <div class="form-group row mx-0">
                <div class="px-1 col-6">
                    <label class="col-sm-6 control-label">セイ  <span class="required_mark">必須</span></label>
                    <input type="text" placeholder="" v-model="userForm.phonetic_last_name" class="required form-control" v-bind:class="{ error_input: userForm.errors.phonetic_last_name.length > 0 }">
                    <div v-if="userForm.errors.phonetic_last_name.length > 0">
                      <div class="error-text" v-for="(item, index) in userForm.errors.phonetic_last_name" :key="index">{{ item }}</div>
                    </div>
                </div>
                <div class="px-1 col-6">
                    <label class="col-sm-6 control-label">メイ  <span class="required_mark">必須</span></label>
                    <input type="text" placeholder="" v-model="userForm.phonetic_first_name" class="required form-control" v-bind:class="{ error_input: userForm.errors.phonetic_first_name.length > 0 }">
                    <div v-if="userForm.errors.phonetic_first_name.length > 0">
                      <div class="error-text" v-for="(item, index) in userForm.errors.phonetic_first_name" :key="index">{{ item }}</div>
                    </div>
                </div>
            </div>

            <div class="form-group">
                <div class="col-sm-12 px-1">
                    <label class="col-sm-12 control-label">性別  <span class="required_mark">必須</span></label>
                    <div class="col-sm-10">
                    <label class="checkbox-inline p-3">
                        <input type="radio" v-model="userForm.gender" value="1">
                        男性
                    </label>
                    <label class="checkbox-inline p-3">
                        <input type="radio" v-model="userForm.gender" value="2">
                        女性
                    </label>
                </div>
            </div>

            <div class="form-group">
                <div class="col-sm-12 px-1">
                    <label class="col-sm-12 control-label">生年月日  <span class="required_mark">必須</span></label>
                    <input type="date" placeholder="" v-model="userForm.old" class="required form-control" v-bind:class="{ error_input: userForm.errors.old.length > 0 }">
                    <div v-if="userForm.errors.old.length > 0">
                      <div class="error-text" v-for="(item, index) in userForm.errors.old" :key="index">{{ item }}</div>
                    </div>
                </div>
            </div>

            <div class="form-group">
                <div class="col-sm-12 px-1">
                    <label class="col-sm-12 control-label">郵便番号(半角数字)  <span class="required_mark">必須</span>　<a target="_blank" href="https://yu-bin.jp/zipcode/">郵便番号検索</a></label>
                    <input type="tel" placeholder="" v-model="userForm.postal_code" class="required form-control" maxlength="8" v-bind:class="{ error_input: userForm.errors.postal_code.length > 0 }">
                    <div v-if="userForm.errors.postal_code.length > 0">
                      <div class="error-text" v-for="(item, index) in userForm.errors.postal_code" :key="index">{{ item }}</div>
                    </div>
                </div>
            </div>

            <div class="form-group">
                <div class="col-sm-12 px-1">
                    <label class="col-sm-12 control-label">都道府県  <span class="required_mark">必須</span></label>
                    <input type="text" placeholder="" v-model="userForm.region" class="required form-control" v-bind:class="{ error_input: userForm.errors.region.length > 0 }">
                    <div v-if="userForm.errors.region.length > 0">
                      <div class="error-text" v-for="(item, index) in userForm.errors.region" :key="index">{{ item }}</div>
                    </div>
                </div>
            </div>

            <div class="form-group">
                <div class="col-sm-12 px-1">
                    <label class="col-sm-12 control-label">住所１　(市区町村)  <span class="required_mark">必須</span></label>
                    <input type="text" placeholder="" v-model="userForm.address_1" class="required form-control" v-bind:class="{ error_input: userForm.errors.address_1.length > 0 }">
                    <div v-if="userForm.errors.address_1.length > 0">
                      <div class="error-text" v-for="(item, index) in userForm.errors.address_1" :key="index">{{ item }}</div>
                    </div>
                </div>
            </div>

            <div class="form-group">
                <div class="col-sm-12 px-1">
                    <label class="col-sm-12 control-label">住所２　(番地、建物名)  <span class="required_mark">必須</span></label>
                    <input type="text" placeholder="" v-model="userForm.address_2" class="required form-control" v-bind:class="{ error_input: userForm.errors.address_2.length > 0 }">
                    <div v-if="userForm.errors.address_2.length > 0">
                      <div class="error-text" v-for="(item, index) in userForm.errors.address_2" :key="index">{{ item }}</div>
                    </div>
                </div>
            </div>

            <div class="form-group">
                <div class="col-sm-12 px-1">
                    <label class="col-sm-12 control-label">電話番号</label>
                    <input type="tel" placeholder="" v-model="userForm.phone" class="form-control" v-bind:class="{ error_input: userForm.errors.phone.length > 0 }">
                    <div v-if="userForm.errors.phone.length > 0">
                      <div class="error-text" v-for="(item, index) in userForm.errors.phone" :key="index">{{ item }}</div>
                    </div>
                </div>
            </div>

        </div>
    </div>
    <div class="form-group">
        <div class="b100 col-sm-12">
            <button type="button" class="bs100 btn btn-primary" @click="user_form_submit()">更新する</button>
            <!-- <input class="bs100 btn btn-primary" type="submit" value="次へ"> -->
        </div>
    </div>

<!--
詳細情報登録

nickname	ハンドルネーム
last_name	ユーザ名 （性）
first_name	ユーザ名 （名）
phonetic_last_name	ユーザ名 フリガナ（姓）
phonetic_first_name	ユーザ名 フリガナ（名）
postal_code	郵便番号
region	都道府県
address_1	住所1
address_2	住所2
phone	電話番号
gender	性別
old	生年月日（年齢）

-->

  </div>
</template>

<script>
export default {
  props: { 
    user: Object
  },
  data() {
    return {
			isError: false,
			userForm: {
				errors: {
          nickname: [],
          last_name: [],
          first_name: [],
          phonetic_last_name: [],
          phonetic_first_name: [],
          postal_code: [],
          region: [],
          address_1: [],
          address_2: [],
          phone: [],
          gender: [],
          old: [],
				},
        nickname: "",
        last_name: "",
        first_name: "",
        phonetic_last_name: "",
        phonetic_first_name: "",
        postal_code: "",
        region: "",
        address_1: "",
        address_2: "",
        phone: "",
        gender: 1,
        old: null,
      },
    }
  },
  methods: {
    // 一般ユーザ更新処理
    async update_user(update_users) {
      this.$store.dispatch('user/update_user', {
        users: update_users['users'],
      }).then(res => {
        console.log(res);
        console.log(update_users);
        alert('更新が完了いたしました。');
        window.scrollTo({
          top: 0,
        });
      }, error => {
        // バックエンドからエラーが返却された場合、ひとまずアラートでメッセージを出力
        console.log(error.response.data);
        if ('error' in error.response.data) {
          alert(error.response.data['error']);
          this.isError = true;
          window.scrollTo({
            top: 0,
          });
        }
      });
      return false;
    },
    user_form_submit() {
      let update_user = {};
      this.isError = false;
			this.userForm.errors.nickname = [];
			this.userForm.errors.postal_code = [];
			this.userForm.errors.region = [];
			this.userForm.errors.address_1 = [];
			this.userForm.errors.address_2 = [];
			this.userForm.errors.phone = [];
			this.userForm.errors.last_name = [];
			this.userForm.errors.first_name = [];
			this.userForm.errors.phonetic_last_name = [];
			this.userForm.errors.phonetic_first_name = [];
			this.userForm.errors.old = [];
      if (!this.userForm.nickname) {
        this.userForm.errors.nickname.push('ニックネームが入力されていません');
        this.isError = true;
      }
      if (!this.userForm.postal_code) {
        this.userForm.errors.postal_code.push('郵便番号が入力されていません');
        this.isError = true;
      } else {
        let check_num = String(this.userForm.postal_code).replace(/[^0-9]/g, '');
        if (check_num == '') {
          this.userForm.errors.postal_code.push('郵便番号が正しく入力されていません');
          this.isError = true;
        }
      }
      if (!this.userForm.region) {
        this.userForm.errors.region.push('都道府県が入力されていません');
        this.isError = true;
      }
      if (!this.userForm.address_1) {
        this.userForm.errors.address_1.push('住所１　(市区町村)が入力されていません');
        this.isError = true;
      }
      if (!this.userForm.address_2) {
        this.userForm.errors.address_2.push('住所２　(番地、建物名)が入力されていません');
        this.isError = true;
      }
      if (this.userForm.phone) {
        let check_num = String(this.userForm.phone).replace(/[^0-9]/g, '');
        if (check_num == '') {
          this.userForm.errors.phone.push('電話番号が正しく入力されていません');
          this.isError = true;
        }
      }
      if (!this.userForm.last_name) {
        this.userForm.errors.last_name.push('姓が入力されていません');
        this.isError = true;
      }
      if (!this.userForm.first_name) {
        this.userForm.errors.first_name.push('名が入力されていません');
        this.isError = true;
      }
      if (!this.userForm.phonetic_last_name) {
        this.userForm.errors.phonetic_last_name.push('セイが入力されていません');
        this.isError = true;
      }
      if (!this.userForm.phonetic_first_name) {
        this.userForm.errors.phonetic_first_name.push('メイが入力されていません');
        this.isError = true;
      }
      if (!this.userForm.old) {
        this.userForm.errors.old.push('生年月日が入力されていません');
        this.isError = true;
      }
      if (this.isError) {
        // document.getElementById("f1").scrollIntoView(true)
        window.scrollTo({
          top: 0,
        });
      } else {
        update_user['users'] = this.userForm;
        this.update_user(update_user);
      }
      return false;
    },
  },
  created() {
    this.userForm.nickname = this.user.nickname;
    this.userForm.last_name = this.user.last_name;
    this.userForm.first_name = this.user.first_name;
    this.userForm.phonetic_last_name = this.user.phonetic_last_name;
    this.userForm.phonetic_first_name = this.user.phonetic_first_name;
    this.userForm.postal_code = this.user.postal_code;
    this.userForm.region = this.user.region;
    this.userForm.address_1 = this.user.address_1;
    this.userForm.address_2 = this.user.address_2;
    this.userForm.phone = this.user.phone;
    if (this.user.gender) {
      this.userForm.gender = this.user.gender;
    }
    this.userForm.old = this.user.old;
  },
  watch: {
    'userForm.postal_code': function(val){
      if (val.length > 6) {
        let _this = this
        new YubinBango.Core(val, function(addr) {
          if (_this.userForm.region==''||_this.userForm.region==null) {
            _this.userForm.region = addr.region // 都道府県
          }
          if (_this.userForm.address_1==''||_this.userForm.address_1==null) {
            _this.userForm.address_1 = addr.locality  // 市区町村
          }
          if (_this.userForm.address_2==''||_this.userForm.address_2==null) {
            _this.userForm.address_2 = addr.street  // 町域
          }
        })
      }
    },
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/mypage/buyer/profile.vue